/**
 * Guarda da tela de aceite dos documentos legais (LGPD-05).
 *
 * Mesmo desenho do `OnboardingGate`, um degrau antes: `needsLegalAcceptance(user)` decide
 * nas duas direcoes. Os layouts (`DashboardLayout`, `AdminLayout`, `InstructorLayout`) e o
 * `OnboardingGate` mandam para `/aceite` quando ha pendencia; este gate manda para o
 * proximo degrau (`nextPathAfterLegal`) quando nao ha. Um predicado so = sem ping-pong.
 *
 * A decisao e tomada UMA vez, com o primeiro `user` conhecido: ao gravar o aceite a
 * pagina faz `setUser(response.user)` e a pendencia some — um redirect reativo tiraria
 * a tela do ar antes de a propria pagina navegar com `replace`.
 */
import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { LoadingOverlay } from '@/components/ui'
import { useAuthStore } from '@/stores/authStore'
import { useThemeInit } from '@/stores/uiStore'
import { needsLegalAcceptance, nextPathAfterLegal } from './onboardingAccess'

export function LegalAcceptanceGate() {
  const { user, isAuthenticated, isLoading, checkAuth } = useAuthStore()

  useThemeInit()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  const [allowed, setAllowed] = useState<boolean | null>(null)
  if (allowed === null && !isLoading && user) {
    setAllowed(needsLegalAcceptance(user))
  }

  if (isLoading && !user) {
    return <LoadingOverlay message="Carregando..." />
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />
  }

  if (allowed === null) {
    return <LoadingOverlay message="Carregando..." />
  }

  if (!allowed) {
    return <Navigate to={nextPathAfterLegal(user)} replace />
  }

  return <Outlet />
}
